import { Component, OnInit, OnDestroy } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { localeEnglish } from 'app/navigation/i18n/en';
import { localeSpanish } from 'app/navigation/i18n/es';
import { TipocambioService } from '../tipocambio/services/tipocambio.service';
import { UtilsService } from '../../shared/services/utils.service';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { CustomSnackbarComponent } from '../../shared/components/custom-snackbar/custom-snackbar.component';


@Component({
    selector   : 'sample',
    templateUrl: './sample.component.html',
    styleUrls  : ['./sample.component.scss']
})
export class SampleComponent implements OnInit, OnDestroy
{
    spanish = localeSpanish;
    english = localeEnglish;
    private unsubscribeAll: Subject<any>;
    private dia;
    private mes;
    private anio;
    private fechaActual;
    /**
     * Constructor
     *
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     */
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private tipoCambio: TipocambioService,
        private utilsService: UtilsService,
        private snackbar: MatSnackBar,
    )
    {
        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(this.english, this.spanish);
        this.unsubscribeAll = new Subject();
    }


    ngOnInit(): void {

        this.dia = new Date().getDate();
        this.mes = (new Date().getMonth() + 1).toString();
        this.anio = new Date().getFullYear();

        if (this.mes.length < 2) {

            this.mes = '0' + this.mes + '';
        }
        if (this.dia < 10) {
            this.dia = '0' + this.dia + '';
        }
        this.fechaActual = this.anio + '-' + this.mes + '-' + this.dia;

       this.tipoCambio.obtenerFechaMayor().subscribe(fecha => {
            if (fecha.result) {
                if (fecha.result < this.fechaActual) {
                    this.snackbar.openFromComponent(CustomSnackbarComponent, { horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['mat-elevation-z3'], duration: 10000 });
                }
            }
       });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.complete();
    }

}
